<template>
    <div>
        <!-- TOAST PARA LOS MENSAJES -->
        <div class="p-d-flex">
            <Toast />
        </div>
        <!-- DIALOGO DE LOADING -->
        <Dialog :baseZIndex="2" :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }">
            <ProgressBar mode="indeterminate" style="height: 0.5em" />
            <span>{{ loadingMensaje }}</span>
        </Dialog>
        <!-- NUEVA PERCEPCION -->
        <Dialog :showHeader="false" position="top" :visible.sync="dialogPercepcion" :closeOnEscape="true"
        :closable="false" :modal="false" :style="{ width: '95vw' }" class="border-round">
            <ComponentPercepcion @closeDialogPercepcion="dialogPercepcion = false"></ComponentPercepcion>
        </Dialog>
        <!-- NUEVA DEDUCCION -->
        <Dialog :showHeader="false" position="top" :visible.sync="dialogDeduccion" :closeOnEscape="true"
        :closable="false" :modal="false" :style="{ width: '95vw' }" class="border-round">
            <ComponentDeduccion @closeDialogDeduccion="dialogDeduccion = false"></ComponentDeduccion>
        </Dialog>
        <!-- NUEVO OTRO PAGO -->
        <Dialog :showHeader="false" position="top" :visible.sync="dialogOtroPago" :closeOnEscape="true"
        :closable="false" :modal="false" :style="{ width: '95vw' }" class="border-round">
            <ComponentOtroPago @closeDialogOtroPago="dialogOtroPago = false"></ComponentOtroPago>
        </Dialog>

        <!-- PERCEPCIONES, DEDUCCIONES, OTROS PAGOS -->
        <TabView>
            <!-- PERCEPCIONES -->
            <TabPanel header="Percepciones">
                <DataTable :value="listPercepciones" :scrollable="true" scrollHeight="400px" scrollDirection="both" >
                    <template #header>
                        <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                            <div class="field col-6 text-left" >
                                <h1>Percepciones</h1>
                            </div>
                            <div class="field col-6 text-right">
                                <Button icon="pi pi-plus" class="p-button-rounded p-button-success p-button-outlined mr-1" @click="NuevaPercepcion"/>
                                <Button icon="pi pi-replay" class="p-button-rounded p-button-info p-button-outlined" />
                            </div>
                        </div>
                    </template>
                    <Column header="Acciones" :styles="{'flex-grow':'1', 'flex-basis':'10px'}" frozen>
                        <template #body="slotProps">
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mr-1" v-tooltip.bottom="'Eliminar'" />
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-info" v-tooltip.bottom="'Editar'" />
                        </template>
                    </Column>
                    <Column field="clave" header="Clave" :styles="{'flex-grow':'1', 'flex-basis':'10px'}"></Column>
                    <Column field="concepto" header="Concepto" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                    <Column field="tipoPercepcion.tipoPercepcion" header="Tipo Percepción" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                </DataTable>
            </TabPanel>
            <!-- DEDUCCIONES -->
            <TabPanel header="Deducciones">
                <DataTable :value="listDeducciones" :scrollable="true" scrollHeight="400px" scrollDirection="both" >
                    <template #header>
                        <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                            <div class="field col-6 text-left" >
                                <h1>Deducciones</h1>
                            </div>
                            <div class="field col-6 text-right">
                                <Button icon="pi pi-plus" class="p-button-rounded p-button-success p-button-outlined mr-1" @click="NuevaDeduccion"/>
                                <Button icon="pi pi-replay" class="p-button-rounded p-button-info p-button-outlined" />
                            </div>
                        </div>
                    </template>
                    <Column header="Acciones" :styles="{'flex-grow':'1', 'flex-basis':'10px'}" frozen>
                        <template #body="slotProps">
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mr-1" v-tooltip.bottom="'Eliminar'" />
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-info" v-tooltip.bottom="'Editar'" />
                        </template>
                    </Column>
                    <Column field="clave" header="Clave" :styles="{'flex-grow':'1', 'flex-basis':'10px'}"></Column>
                    <Column field="concepto" header="Concepto" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                    <Column field="tipoDeduccion.tipoDeduccion" header="Tipo Deducción" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                </DataTable>
            </TabPanel>
            <!-- OTROS PAGOS -->
            <TabPanel header="Otros Pagos">
                <DataTable :value="listOtrosPagos" :scrollable="true" scrollHeight="400px" scrollDirection="both" >
                    <template #header>
                        <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                            <div class="field col-6 text-left" >
                                <h1>Otros Pagos</h1>
                            </div>
                            <div class="field col-6 text-right">
                                <Button icon="pi pi-plus" class="p-button-rounded p-button-success p-button-outlined mr-1" @click="NuevoOtroPago"/>
                                <Button icon="pi pi-replay" class="p-button-rounded p-button-info p-button-outlined" />
                            </div>
                        </div>
                    </template>
                    <Column header="Acciones" :styles="{'flex-grow':'1', 'flex-basis':'10px'}" frozen>
                        <template #body="slotProps">
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mr-1" v-tooltip.bottom="'Eliminar'" />
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-info" v-tooltip.bottom="'Editar'" />
                        </template>
                    </Column>
                    <Column field="clave" header="Clave" :styles="{'flex-grow':'1', 'flex-basis':'10px'}"></Column>
                    <Column field="concepto" header="Concepto" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                    <Column field="tipoOtroPago.tipoOtroPago" header="Tipo Otro Pago" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                </DataTable>
            </TabPanel>
        </TabView>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import ComponentPercepcion from './Percepcion'
    import ComponentDeduccion from './Deduccion'
    import ComponentOtroPago from './OtroPago'

    export default {
        components: {
            ComponentPercepcion,
            ComponentDeduccion,
            ComponentOtroPago,
        },
        data() {
            return {
                dialogPercepcion: false,
                dialogDeduccion: false,
                dialogOtroPago: false,

                loading: false,
                loadingMensaje: '',
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            //CONCEPTOS
            percepcion(){
                return this.$store.state.percepcionStore;
            },
            deduccion(){
                return this.$store.state.deduccionStore;
            },
            otroPago(){
                return this.$store.state.otroPagoStore;
            },
            
            //LISTAS
            listPercepciones(){
                return this.$store.state.percepcionesStore;
            },
            listDeducciones(){
                return this.$store.state.deduccionesStore;
            },
            listOtrosPagos(){
                return this.$store.state.otrosPagosStore;
            },
        },
        created() {
            this.Iniciales();
        },
        methods: {
            async Iniciales(){
                this.loading = true;
                await this.GetPercepciones();
                await this.GetDeducciones();
                await this.GetOtrosPagos();
                await this.GetTipoPercepcion();
                await this.GetTipoDeduccion();
                await this.GetTipoOtroPago();
                this.loading = false;
            },

            async GetPercepciones(){
                try{
                    this.loadingMensaje = 'Consultando Percepciones...';
                    let respuesta = await axios.get("Nomina/GetPercepciones/" + this.token.empresaBase);
                    let x =  respuesta.data
                    this.$store.state.percepcionesStore = x;
                }catch(error){
                    console.log(error)
                }
            },

            async GetDeducciones(){
                try{
                    this.loadingMensaje = 'Consultando Deducciones...';
                    let respuesta = await axios.get("Nomina/GetDeducciones/" + this.token.empresaBase);
                    let x =  respuesta.data
                    this.$store.state.deduccionesStore = x;
                }catch(error){
                    console.log(error)
                }
            },

            async GetOtrosPagos(){
                try{
                    this.loadingMensaje = 'Consultando Otros Pagos';
                    let respuesta = await axios.get("Nomina/GetOtroPagos/" + this.token.empresaBase);
                    let x =  respuesta.data
                    this.$store.state.otrosPagosStore = x;
                }catch(error){
                    console.log(error)
                }
            },
            
            async GetTipoPercepcion(){
                if(this.$store.state.tipoPercepcionStore.length != 0){
                    return;
                }
                try{
                    this.loadingMensaje = 'Consultando Percepciones del SAT';
                    let respuesta = await axios.get("Nomina/GetTipoPercepcion/");
                    let x =  respuesta.data
                    this.$store.state.tipoPercepcionStore = x;
                }catch(error){
                    console.log(error)
                }
            },

            async GetTipoDeduccion(){
                if(this.$store.state.tipoDeduccionStore.length != 0){
                    return;
                }
                try{
                    this.loadingMensaje = 'Consultanod Deducciones del SAT';
                    let respuesta = await axios.get("Nomina/GetTipoDeduccion/");
                    let x =  respuesta.data
                    this.$store.state.tipoDeduccionStore = x;
                }catch(error){
                    console.log(error)
                }
            },

            async GetTipoOtroPago(){
                if(this.$store.state.tipoOtroPagoStore.length != 0){
                    return;
                }
                try{
                    this.loadingMensaje = 'Consultanod Otros Pagos del SAT';
                    let respuesta = await axios.get("Nomina/GetTipoOtroPago/");
                    let x =  respuesta.data
                    this.$store.state.tipoOtroPagoStore = x;
                }catch(error){
                    console.log(error)
                }
            },

            NuevaPercepcion(){
                let objPercepcion = {
                    id: 0,
                    tipoPercepcion: {},
                    clave: '',
                    concepto: '',
                };
                this.$store.state.percepcionStore = { ...objPercepcion }
                this.dialogPercepcion = true;
            },
            
            NuevaDeduccion(){
                let objDeduccion = {
                    id: 0,
                    tipoDeduccion: {},
                    clave: '',
                    concepto: '',
                };
                this.$store.state.deduccionStore = { ...objDeduccion }
                this.dialogDeduccion = true;
            },
            
            NuevoOtroPago(){
                let objOtroPago = {
                    id: 0,
                    tipoOtroPago: {},
                    clave: '',
                    concepto: '',
                };
                this.$store.state.otroPagoStore = { ...objOtroPago }
                this.dialogOtroPago = true;
            },
        },
    }
    </script>
    <style>

    </style>